/* Inspired by CHANGE page (ibc-* sections) – see docs/features/inspired-by-change-page.md */
(function (root) {
  var IbcPage = {
    // Image pairs render both images; CSS shows the one named by data-showing.
    togglePair: function (pair) {
      var button = pair.querySelector('[data-ibc-pair-toggle]');
      var original = pair.dataset.showing !== 'original';
      pair.dataset.showing = original ? 'original' : 'photo';
      button.setAttribute('aria-pressed', String(original));
      button.setAttribute('aria-label', button.getAttribute(original ? 'data-label-to-photo' : 'data-label-to-original'));
    },

    // Liquid's money filters use HTML entities (&pound;). DOMParser decodes
    // them without running anything, and the result goes in as text.
    decodeEntities: function (value) {
      if (!root.DOMParser) return value;
      return new root.DOMParser().parseFromString('<!doctype html><body>' + value, 'text/html').body.textContent;
    },

    // Every tier's figures arrive already formatted by Liquid, so this only swaps text.
    applyTier: function (container, tier) {
      if (!tier) return;
      Array.prototype.forEach.call(container.querySelectorAll('[data-ibc-price]'), function (field) {
        var value = tier[field.dataset.ibcPrice];
        if (value != null) field.textContent = IbcPage.decodeEntities(value);
      });
      // Plan buttons go to the chosen size's own Library or Bundle variant.
      Array.prototype.forEach.call(container.querySelectorAll('[data-ibc-href]'), function (link) {
        var url = tier[link.dataset.ibcHref];
        if (url) link.setAttribute('href', url);
      });
    },

    // Safari's native controls dim the whole frame while the film is paused,
    // which turns this pale film grey. Until someone presses play, the film
    // shows its poster in full colour under our own play button instead.
    prepareFilm: function (player) {
      var video = player.querySelector('video');
      if (!video || player.dataset.state === 'playing') return;
      video.controls = false;
      player.dataset.state = 'ready';
    },

    playFilm: function (player) {
      var video = player.querySelector('video');
      if (!video) return;
      video.controls = true;
      player.dataset.state = 'playing';
      // The play button hides, so keyboard focus moves to the film's own controls
      video.focus();
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    },

    resetFilm: function (player) {
      player.dataset.state = '';
      IbcPage.prepareFilm(player);
      // Without controls the film can't be operated, so focus goes back to the button
      var video = player.querySelector('video');
      var button = player.querySelector('[data-ibc-film-play]');
      if (button && root.document && root.document.activeElement === video) button.focus();
    }
  };

  function prepareFilms(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ibc-film]'), IbcPage.prepareFilm);
  }

  // Every ibc-* section includes this script, so it can run more than once;
  // listeners bound twice would toggle a pair twice and cancel out.
  if (root.document && !root.document.documentElement.hasAttribute('data-ibc-page-bound')) {
    root.document.documentElement.setAttribute('data-ibc-page-bound', '');
    root.document.addEventListener('click', function (evt) {
      var button = evt.target.closest && evt.target.closest('[data-ibc-pair-toggle]');
      if (button) IbcPage.togglePair(button.closest('[data-ibc-pair]'));
      var play = evt.target.closest && evt.target.closest('[data-ibc-film-play]');
      if (play) IbcPage.playFilm(play.closest('[data-ibc-film]'));
    });

    // Media events don't bubble, so this listens in the capture phase
    root.document.addEventListener('ended', function (evt) {
      var player = evt.target.closest && evt.target.closest('[data-ibc-film]');
      if (player) IbcPage.resetFilm(player);
    }, true);

    // The script is deferred, so the sections are already parsed
    prepareFilms(root.document);
    // The theme editor re-renders a section without re-running its scripts
    root.document.addEventListener('shopify:section:load', function (evt) {
      prepareFilms(evt.target);
    });

    root.document.addEventListener('change', function (evt) {
      var select = evt.target.closest && evt.target.closest('[data-ibc-tier-select]');
      if (!select) return;
      var container = select.closest('[data-ibc-pricing]');
      var tiers;
      try {
        tiers = JSON.parse(container.querySelector('[data-ibc-tiers]').textContent);
      } catch (e) {
        return;
      }
      IbcPage.applyTier(container, tiers[Number(select.value)]);
    });
  }

  root.IbcPage = IbcPage;
  if (typeof module !== 'undefined' && module.exports) module.exports = IbcPage;
})(typeof window !== 'undefined' ? window : globalThis);
